import { ScreenId } from '@core/router'

import { screenNames } from '../constants/screenNames'
import { type TScreenName } from '../types/screenNameTypes'

const isSearchPath = (pathname: string): boolean =>
    pathname === '/search' || pathname.startsWith('/search/')

const currentPathname = (): string =>
    typeof window === 'undefined' ? '' : window.location.pathname

// Explicit screen from the router's ScreenId (backend-driven) — replaces audio-web's
// getScreenName() regex over the pathname. Unmapped ids -> 'not_supported_screen'.
export const resolveScreen = (screenId: ScreenId, pathname = currentPathname()): TScreenName => {
    if (screenId === ScreenId.ERROR) {
        return isSearchPath(pathname) ? 'search' : 'not_found'
    }

    return screenNames[screenId] ?? 'not_supported_screen'
}
